import styled, {css} from "styled-components";
import {ButtonProps} from "@FRAMEWORK/ui/types/d";
import React from "react";

interface Props extends ButtonProps {
	text?: string | boolean;
	size?: "default" | "large" | "small";
	types?: "confirm" | "mainCtn" | "subCtn" | "line" | "disabled" | "accept" | "cancel" | "alert" | "whiteCtn";
	onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const StyledButton = styled.button<Props>`
	border-radius: 8px;
	font-size: var(--regular-size);
	font-family: "PT-semibold";
	font-weight: normal;
	white-space: nowrap;
	overflow: hidden;

	&[type="button"]:disabled {
		background-color: var(--disable-line-color);
		color: var(--disable-text-color);
		cursor: unset;
	}

	${props => {
		if (props.types === "confirm") {
			return css`
				border-color: transparent;
				background-color: var(--brand-color);
				color: var(--title-color);
				&[type="button"]:disabled {
					background-color: var(--disable-line-color);
					color: var(--disable-text-color);
					cursor: unset;
				}
			`;
		}
		if (props.types === "mainCtn") {
			return css`
				border-color: transparent;
				background-color: var(--primary-color);
				color: #fff;
				&[type="button"]:disabled {
					background-color: var(--disable-line-color);
					color: var(--disable-text-color);
					cursor: unset;
				}
			`;
		}
		if (props.types === "subCtn") {
			return css`
				border-color: transparent;
				background-color: var(--secondary-color);
				color: #fff;
				&[type="button"]:disabled {
					background-color: var(--disable-line-color);
					color: var(--disable-text-color);
					cursor: unset;
				}
			`;
		}
		if (props.types === "whiteCtn") {
			return css`
				border-color: #fff;
				background-color: #fff;
				color: #111;
				&[type="button"]:disabled {
					background-color: var(--disable-line-color);
					color: var(--disable-text-color);
					cursor: unset;
				}
			`;
		}

		if (props.types === "line") {
			return css`
				border: 1px solid var(--border-color);
				background-color: #fff;
				color: var(--secondary-color);
				&[type="button"]:disabled {
					background-color: var(--disable-line-color);
					color: var(--disable-text-color);
					cursor: unset;
				}
			`;
		}

		if (props.types === "disabled") {
			return css`
				border-color: transparent;
				background-color: var(--disable-line-color);
				color: var(--disable-text-color);
				&[type="button"]:disabled {
					background-color: var(--disable-line-color);
					color: var(--disable-text-color);
					cursor: unset;
				}
			`;
		}

		if (props.types === "accept") {
			return css`
				background: var(--brand-color);
				color: #fff;
				&[type="button"]:disabled {
					background-color: var(--disable-line-color);
					color: var(--disable-text-color);
					cursor: unset;
				}
			`;
		}

		if (props.types === "cancel") {
			return css`
				background: var(--disable-line-color);
				border: 1px solid var(--disable-line-color);
				color: var(--caption-color);
				&[type="button"]:disabled {
					background-color: var(--disable-line-color);
					color: var(--disable-text-color);
					cursor: unset;
				}
			`;
		}

		if (props.types === "alert") {
			return css`
				color: #fff;
				background: var(--alert-color);
				&[type="button"]:disabled {
					background-color: var(--disable-line-color);
					color: var(--disable-text-color);
					cursor: unset;
				}
			`;
		}
	}}

	${props => {
		if (props.size === "default") {
			return `
					height: 32px;
					padding: 4px 16px;
					font-size: var(--basic-size);`;
		}
		if (props.size === "large") {
			return `
					height: 40px;
					padding: 4px 32px;
					font-size: var(--regular-size);`;
		}
		if (props.size === "small") {
			return `
					height: 32px;
					padding: 4px 16px;
					font-size: var(--basic-size);`;
		}
	}};
	+ button {
		margin-left: 12px;
	}

	> span {
		position: absolute;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		border: none;
		overflow: hidden;
		clip: rect(0 0 0 0);
	}
`;

const TextDefaultButton = ({text, ...props}: Props) => (
	<StyledButton type="button" {...props}>
		{text}
	</StyledButton>
);

export default TextDefaultButton;
